// CONCATENATED MODULE: ./source/scripts/components/ProductQuickshop.js

class ProductDesignStudio {
  constructor(options) {
    this.$el = options.$el;
    this.id = options.id;
    this.sectionContext = options.sectionContext;
    this.initialVariant = options.initialVariant || null;
    this.quickShopSelector = options.quickShopSelector ? options.quickShopSelector : `#shopify-section-${this.id} [data-product-quickshop]`;
    this.$quickShop = window.jQuery(this.quickShopSelector);
    this.quickshopSpinner = this.$quickShop[0].querySelector('.quickshop-spinner');
    this.modalClass = options.modalClass;
    this.loaded = false;
    this.richText = null;
    this.productDetails = null;
    this.trigger = options.trigger;
    this.isOpen = false;
    this.openingAddToCart = false;
    this.modal = options.modal ? options.modal : null;
    this.quickshopContainer = options.quickshopContainer ? options.quickshopContainer : null;
    this.view = options.view ? options.view : 'product-quickshop';
    this.url = options.productUrl ? options.productUrl : this.$el.data('product-quickshop-url');
    this.modalCallbacks = {
      onOpen: this._open.bind(this),
      onClose: this._close.bind(this),
      onGoBack: this._goBack.bind(this)
    };
    

    this._initialize();
  }

  _initialize() {
    if (this.modal == null) {
      this.modal = new Modal(this.modalCallbacks);
      this.modal.open(this.quickShopSelector, this.modalClass);
    }

    this.isOpen = true;
    let $quickShopModalContent = this.modal.$modalInner.find('[data-modal-content]');

    if (this.quickshopContainer) {
      $quickShopModalContent = window.jQuery(this.quickshopContainer);
    }

    fetch(this.url.indexOf('?') >= 0 ? `${this.url}&view=design-studio` : `${this.url}?view=design-studio`).then(response => response.text()) // Return text string of the HTML
    .then(data => {
      // Convert the HTML string into a document object
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html'); // Locate the product wrapper

      const productSection = doc.querySelector('[data-product-wrapper]'); // Locate the product settings

      const staticProduct = doc.querySelector('[data-section-type="static-product"]'); // Converts JSON into object for us to grab the settings

      this.productSettings = JSON.parse(staticProduct.innerHTML); // Stop populating the modal if it was closed before the content was loaded

      if (!this.isOpen) {
        return;
      }

      $quickShopModalContent.html(productSection.innerHTML); // Inserting product wrapper into modal

      initShopifyProductReviews();
      setupRippleEffect($quickShopModalContent[0]);

      this.gallery = $quickShopModalContent[0].querySelector('[data-product-gallery]');
      this.$details = $quickShopModalContent.find('[data-product-details]');
      this.$description = $quickShopModalContent.find('[data-product-description]');
      this.productEl = $quickShopModalContent[0];
      this.context = this.productSettings.context;
      this.settings = this.productSettings.settings;
      this.product = this.productSettings.product;
      this.openRequestQuote = $quickShopModalContent.find('[data-open-request-quote]');
      this.formRequestQuote = $quickShopModalContent.find('#request_a_quote');

      this._onQuickshopLoaded();

    }).catch();
  }

  _onQuickshopLoaded() {
    if (this.loaded) {
      return;
    }

    if (this.$description && this.$description.length) {
      this.richText = new RichText(this.$description);
    }

    const mainImage = this.gallery.querySelector('figure.product-gallery--image').cloneNode(true);
    this.gallery.appendChild(mainImage);
    this.gallery.querySelector('.product-gallery--viewer').remove();
    this.gallery.querySelector('.product-gallery--navigation').remove();

    const options = {
      gallery: this.gallery,
      $details: this.$details,
      context: this.productSettings.context,
      sectionContext: this.sectionContext,
      settings: this.productSettings.settings,
      product: this.productSettings.product,
      useHistory: false,
      isQuickshop: true,
      initialVariant: this.initialVariant,
      productEl: this.productEl
    };
    this.modal.position();
    this.modal.finishedLoading();
    this.loaded = true;

    window.requestAnimationFrame(() => {
      this.productDetails = new ProductDetails(options);
    });
    
    this.openRequestQuote.on('click', () => {
      this.modal.$modalInner[0].querySelector('.modal-close').removeAttribute('data-modal-close');
      this.productEl.classList.add('request-a-quote');
    });

    this.modal.$modalInner[0].querySelector('.modal-close').addEventListener('click', this.modalCallbacks.onGoBack);

    this.formRequestQuote.on('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(this.formRequestQuote[0]);
      const firstName = formData.get('first_name');
      const lastName = formData.get('last_name');
      const email = formData.get('email');
      const zip = formData.get('zip');
      const company = formData.get('company');
      const industry = formData.get('industry');
      const occupation = formData.get('occupation');
      const message = formData.get('message');
      const projectName = formData.get('projectName');
      const projectLocation = formData.get('projectLocation');
      const projectValue = formData.get('projectValue');
      const projectStage = formData.get('projectStage');
      const projectSegment = formData.get('projectSegment');
      const productCount = formData.get('productCount');
      function myCallback() {
        var item = {
          "first_name": firstName,
          "last_name": lastName,
          "email": email,
          "zipcode": zip,
          "company": company,
          "industry": industry,
          "occupation": occupation,
          "message_details": message,
          "project_name ": projectName,
          "project_location": projectLocation,
          "project_value": projectValue,
          "project_stage ": projectStage,
          "project_segment": projectSegment,
          "project_count": productCount,
        };
        klaviyo.track("Request a Quote", item);
      }
        
      klaviyo.identify({
          'email' : email,
          'first_name' : firstName,
          'last_name' : lastName
      }, myCallback);

      klaviyo.identify({}).then(() => {
        this.productEl.classList.add('form-submitted');
      });
    });
  }

  _open() {// do nothing
  }

  _close() {
    if (!this.openingAddToCart) {
      // this.trigger.focus();
    }

    

    if(this.productEl.classList.contains('request-a-quote')) {
      this.modal.$modalInner[0].querySelector('.modal-close').removeAttribute('data-modal-close');
      this.productEl.classList.remove('request-a-quote');
    } else {
      this.modal.$modalInner[0].querySelector('.modal-close').setAttribute('data-modal-close', true);
      this.loaded = false;
      this.isOpen = false;
      this.$quickShop.empty();
      this.$quickShop.html(this.quickshopSpinner);
  
      this.modal.unload();
      this.productEl.classList.remove('request-a-quote');
      this.productEl.classList.remove('form-submitted');
    }
  }

  _goBack() {
    if(this.productEl.classList.contains('request-a-quote') && this.productEl.classList.contains('form-submitted')) {
      this._close();
    } else if(this.productEl.classList.contains('request-a-quote')) {
      this.productEl.classList.remove('request-a-quote');
    } else {
      this.modal.$modalInner[0].querySelector('.modal-close').removeEventListener('click', this.modalCallbacks.onGoBack);
      this._close();
    }
  }

  unload() {
    if (this.isLoaded) {
      return this._close().then(() => {
        if (this.productDetails) {
          this.productDetails.unload();
        }

        if (this.richText) {
          this.richText.unload();
        }
      });
    }

    return Promise.resolve();
  }

}

window.ProductDesignStudio = ProductDesignStudio;